import { hasActiveSession } from './session';

export default function isAuthenticated() {
  return hasActiveSession();
}